// src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./Components/User/Customer_Login/Login";
import Register from "./Components/User/Customer_Login/Register";
import CustomerDashboard from "./Components/User/Customer_Dashboard/Customer_dashboard";
import ProductRepairDetails from "./Components/User/Customer_Dashboard/ProductRepairDetails";
import ProductDetails from "./Components/Admin/Product_Repair/ProductDetails";
import RegisteredProduct from "./Components/User/Customer_Registered_Product/RegisteredProduct";
import Product from "./Components/Admin/Customer_Registered_Product/RegisteredProduct";
import Scheme from "./Components/User/Scheme/UserScheme";
import SchemeAdmin from "./Components/Admin/Scheme/SchemeForm"
import SchemeStatus from "./Components/User/Scheme/SchemeStatus";
import SecureHome from "./Components/User/Customer_Dashboard/SecureHome"; 
import ProtectedRoute from "./Components/User/Protected/ProtectedRoute";
import AdminLogin from "./Components/Admin/Admin_Login/AdminLogin";
import AdminDashboard from "./Components/Admin/Admin_Login/AdminDashboard";
import AdminProtectedRoute from "./Components/Admin/Admin_Protected/AdminProtectedRoute";
import AdminViewWarrantyExtended from "./Components/Admin/3_Months_Warranty_Details/AdminViewWarrantyExtended";
import RegisteredCustomer from "./Components/Admin/User/RegisteredCustomer";
import ForgotPassword from "./Components/User/Customer_Login/ForgotPassword";
import ResetPassword from "./Components/User/Customer_Login/ResetPassword";
import AdminResetPassword from "./Components/Admin/Admin_Login/AdminResetPassword";
import CustomerScheme from './Components/Admin/CustomerScheme/CustomerScheme';
import CustomerAwr from "./Components/Admin/Customer_Awr/ProductDetails"
import AllScheme from "./Components/Admin/Scheme/AllScheme";
import CheckStatus from "./Components/User/Ticket_Status/ExternalTicketStatus/CheckStatus";
import AWR from "./Components/User/AdvanceWarrantyReplacement/AWR";
import AWRRecords from "./Components/User/AdvanceWarrantyReplacement/AWR-Records-Customer";
import AgreementForm from "./Components/User/Agreement/Agreement-Form";
import AgreementDetails from "./Components/Admin/Agreement/AgreementDetails";
import AgreementDetailsPrint from "./Components/Admin/Agreement/AgreementDetailsPrint";
import CustomerAgreementDetails from "./Components/User/Agreement/CustomerAgreementDetails";
import CustomerAgreementDetailsPrint from "./Components/User/Agreement/CustomerAgreementDetailsPrint";
function App() {


  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/admin/reset-password/:token" element={<AdminResetPassword />} />
        <Route path="serviceProduct/ticketStatus" element={<CheckStatus/>}/>
        <Route element={<AdminProtectedRoute />}>
          <Route path="/admin/dashboard" element={<AdminDashboard />}>
            <Route path="registered-customer" element={<RegisteredCustomer />} />
            <Route path="WarrantyExtended" element={<AdminViewWarrantyExtended />} />
            <Route path="agreement-details" element={<AgreementDetails />} />
            <Route path="agreement-details-print" element={<AgreementDetailsPrint />} />
            <Route path="registered/product" element={<Product/>} />
            <Route path="ProductRepair" element={< ProductDetails />}/>
            <Route path="Scheme" element={<SchemeAdmin/>}/>
            <Route path="CustomerAwr" element={<CustomerAwr />} />
            <Route path="CustomerScheme" element={<CustomerScheme/>}/>    
            <Route path="allScheme" element={<AllScheme/>}/>     
        
          </Route>
        </Route>

        <Route element={<ProtectedRoute  />}>
          <Route path="/customer_dashboard" element={<CustomerDashboard />}>
            <Route path="registered_product" element={<RegisteredProduct />} />
            <Route path="registered_product_details" element={<ProductRepairDetails />} />
            <Route path="scheme" element={<Scheme />} />
            <Route path="SchemeStatus" element={<SchemeStatus />} />
            <Route path="awr" element={<AWR />} />
            <Route path="awr/records" element={<AWRRecords />} />
            <Route path="agreement-form" element={<AgreementForm />} />
            <Route path="customer-agreement-details" element={<CustomerAgreementDetails />} />
            <Route path="customer-agreement-details-print" element={<CustomerAgreementDetailsPrint />} />
            <Route index element={<SecureHome />} /> {/* Ensure SecureHome is correctly imported */}
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
